<template>
  <div class="modal-decline-message">
    <p v-if="declineCode">
      <span class="modal-decline-message-title"
        >{{ $tc('SignupPage.RegistrationPage.errors.createStripeError.declineCodeLabel') }}：</span
      >{{ declineCode }}
    </p>
    <p v-if="description">
      <span class="modal-decline-message-title"
        >{{ $tc('SignupPage.RegistrationPage.errors.createStripeError.descriptionLabel') }}：</span
      >{{ description }}
    </p>
    <p v-if="nextUserAction">
      <span class="modal-decline-message-title"
        >{{
          $tc('SignupPage.RegistrationPage.errors.createStripeError.nextUserActionLabel')
        }}：</span
      >{{ nextUserAction }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * 共通 モーダル 拒否コード テンプレート
 */
export default defineComponent({
  name: 'ModalDeclineMessageParts',
  props: {
    declineCode: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    nextUserAction: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.modal-decline-message {
  width: 100%;
  text-align: left;
  @include fontSetTextMedium();

  letter-spacing: 0.04em;
  margin-top: 16px;
  padding: 5px 0;

  &-title {
    color: $gray50;
  }

  &:first-child {
    margin-top: 36px;
  }
}
</style>
